<template>
  <div class="subscription-page">
    <h1>订阅</h1>
    <div class="user-options clearfix">
      <el-select
        style="width: 80px"
        v-model="curChannel.selectValue"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          v-bind:key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <DatePicker @datePickedChange="datePickedChange"></DatePicker>
      <el-button type="primary" @click="doInquery">查询</el-button>
    </div>
    <div class="display-type">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="表格" name="table" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="柱状图" name="bar" class="bar-container">
          <div v-loading="loading">
            <CustomBar :options="barOptions1" class="bar"></CustomBar>
            <CustomBar :options="barOptions2" class="bar"></CustomBar>
          </div>
        </el-tab-pane>
        <el-tab-pane label="折线图" name="line">
          <div v-loading="loading">
            <CustomLine :options="lineOptions"></CustomLine>
          </div>
        </el-tab-pane>
        <!--<el-tab-pane label="饼状图" name="pie">饼图</el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import CustomTable from '../../components/CustomTable'
import CustomBar from '../../components/CustomBar'
import CustomLine from '../../components/CustomLine'
import DatePicker from '../../components/DatePicker'

export default {
  components: {
    CustomTable,
    CustomBar,
    CustomLine,
    DatePicker
  },
  data() {
    return {
      curChannel: {
        selectValue: 'total',
        content: ''
      },
      channels: this.$store.state.channels,
      tableOptions: {
        defaultSort: {
          prop: 'date',
          order: 'descending'
        },
        theader: [
          {
            name: 'date',
            label: '日期',
            sortable: true,
            fixed: true,
            width: '100px'
          },
          {
            name: 'totalCount',
            label: '订阅与续订次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'payValue',
            label: '订阅金额',
            sortable: true,
            fix: true,
            width: '220px'
          },
          {
            name: 'normalCount',
            label: '订阅次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'newNormalCount',
            label: '新用户订阅次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'testCount',
            label: '测试订阅次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'renewCount',
            label: '续订次数',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'cancelCount',
            label: '取消订阅次数',
            sortable: true,
            fix: true,
            width: '160px'
          }
        ]
      },
      barOptions1: {
        title: '订阅次数',
        legend: ['付费订阅', '新用户付费订阅', '续订', '取消订阅'],
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '次数',
          type: 'value'
        },
        series: [
          {
            name: '付费订阅',
            type: 'bar',
            data: []
          },
          {
            name: '新用户付费订阅',
            type: 'bar',
            data: []
          },
          {
            name: '续订',
            type: 'bar',
            data: []
          },
          {
            name: '取消订阅',
            type: 'bar',
            data: []
          }
        ]
      },
      barOptions2: {
        title: '订阅金额',
        legend: ['订阅金额'],
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '金额',
          value: 'value'
        },
        series: [
          {
            name: '订阅金额',
            type: 'bar',
            data: []
          }
        ]
      },
      lineOptions: {
        title: '订阅',
        legend: ['订阅金额'],
        xAxis: {
          name: '日期',
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          name: '金额',
          type: 'value'
        },
        series: [
          {
            name: '订阅金额',
            type: 'line',
            smooth: true,
            data: []
          }
        ]
      },
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ],
      activeName: 'bar',
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.stats_query_subscriptions,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.curChannel.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
              this.lineOptionBuild(res.data.data)
              this.barOptionsBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    //柱状图配置
    barOptionsBuild(data) {
      this.barOptions1.xAxis.data = []
      this.barOptions2.xAxis.data = []
      for (let i = 0; i < this.barOptions1.series.length; i++) {
        this.barOptions1.series[i].data = []
      }
      for (let i = 0; i < this.barOptions2.series.length; i++) {
        this.barOptions2.series[i].data = []
      }
      let item
      for (let j in data) {
        item = data[j]
        this.barOptions1.xAxis.data.push(item.date)
        this.barOptions2.xAxis.data.push(item.date)

        this.barOptions1.series[0].data.push(item.normalCount)
        this.barOptions1.series[1].data.push(item.newNormalCount)
        this.barOptions1.series[2].data.push(item.renewCount)
        this.barOptions1.series[3].data.push(item.cancelCount)

        this.barOptions2.series[0].data.push(item.payValue)
      }
    },
    // 折线图配置
    lineOptionBuild(data) {
      this.lineOptions.xAxis.data = []
      for (let i = 0; i < this.lineOptions.series.length; i++) {
        this.lineOptions.series[i].data = []
      }
      let item
      for (let j in data) {
        item = data[j]
        this.lineOptions.xAxis.data.push(item.date)
        this.lineOptions.series[0].data.push(item.payValue)
      }
    },
    doInquery() {
      this.getList()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.subscription-page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .bar-container {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .bar {
        margin-left: 10px;
        display: inline-block;
        width: 450px;
        height: 300px;
      }
    }
  }
}
</style>
